"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _globalization = require("./globalization");
Object.keys(_globalization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _globalization[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _globalization[key];
    }
  });
});